module.exports = __webpack_public_path__ + "static/slovnicek-project-management-072aefd46d332565a96d5160744a1ac2.jpg";